import { render, staticRenderFns } from "./AppModeless.vue?vue&type=template&id=08a04867&scoped=true"
import script from "./AppModeless.vue?vue&type=script&lang=js"
export * from "./AppModeless.vue?vue&type=script&lang=js"
import style0 from "./AppModeless.vue?vue&type=style&index=0&id=08a04867&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a04867",
  null
  
)

export default component.exports